import type { TimeOfDay } from "../types";

export const TIME_OF_DAY_ORDER: readonly TimeOfDay[] = ["night", "morning", "afternoon", "evening"];

export interface TimeOfDayProfile {
  label: string;
  tint: string;
  tintOpacity: number;
  lightIntensity: number;
  lightRadius: number;
}

const PROFILES: Record<TimeOfDay, TimeOfDayProfile> = {
  night: { label: "Night", tint: "#22345f", tintOpacity: 0.72, lightIntensity: 4.2, lightRadius: 1.22 },
  morning: { label: "Morning", tint: "#ffe5ba", tintOpacity: 0.18, lightIntensity: 1.35, lightRadius: 1 },
  afternoon: { label: "Afternoon", tint: "#ffffff", tintOpacity: 0, lightIntensity: 1, lightRadius: 1 },
  evening: { label: "Evening", tint: "#8b4e2e", tintOpacity: 0.38, lightIntensity: 2.35, lightRadius: 1.1 },
};

export function timeOfDayProfile(value?: TimeOfDay): TimeOfDayProfile {
  return PROFILES[value ?? "afternoon"];
}

export function timeOfDayIndex(value?: TimeOfDay): number {
  return Math.max(0, TIME_OF_DAY_ORDER.indexOf(value ?? "afternoon"));
}
